module.exports = __webpack_public_path__ + "static/media/logo-icon-white.5f929259.svg";